import React, { useEffect, useState } from 'react';
import { IVehicleDetails } from '@/types';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import { imageLoader } from '@/utils/imageLoader';
import { fetchVehicleInfo } from '@/components/fakeDoor/api';
import {
    CardContainer,
    TextContainer,
    ModelText,
    RegistrationText,
    VariantText,
} from './styles';
import { getIconFromMake } from '../../utils';

interface CarDetailCardProps {
    carData: IVehicleDetails;
}

const CarDetailCard: React.FC<CarDetailCardProps> = ({ carData }) => {
    // Format display text based on available data
    console.log('carData :: ', carData);

    const [imageData, setImageData] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const visData = await fetchVehicleInfo(
                    carData?.model_id as number
                );
                console.log('VisData', visData);
                console.log('VisData type:', typeof visData);
                console.log('VisData length:', visData?.length);

                let imageUrl = '';
                if (
                    typeof visData === 'string' &&
                    visData.trim() !== '' &&
                    visData !== '""'
                ) {
                    imageUrl = visData.replace(/^["']|["']$/g, '').trim();
                }
                setImageData(imageUrl);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (carData?.model_id) {
            fetchData();
        }
    }, [carData?.model_id]);

    const modelText = [
        carData.vehicle_make,
        carData.vehicle_model,
        carData.fuel_type,
    ]
        .filter(Boolean)
        .join('  ');

    const variantText = [carData.variant, carData.fuel_type]
        .filter(Boolean)
        .join(' • ');

    // Process the image URL
    const processedImageUrl =
        imageData && imageData.trim() !== ''
            ? imageData.replace(/^["']|["']$/g, '')
            : resolvePath(getIconFromMake(carData?.vehicle_make)) ||
              resolvePath('/images/seo/CarImage.png');

    console.log('Original imageData:', imageData);
    console.log('Processed image URL:', processedImageUrl);

    return (
        <CardContainer>
            <TextContainer>
                <ModelText>{modelText}</ModelText>
                <RegistrationText>
                    {carData.vehicle_number || '-- -- --'}
                </RegistrationText>
                <VariantText>{variantText}</VariantText>
            </TextContainer>
            <Image
                loader={imageLoader}
                src={processedImageUrl}
                width={122}
                height={68}
                alt="Car-Image"
            />
        </CardContainer>
    );
};

export default CarDetailCard;
